import {GameObject} from "../base/GameObject";
import * as PIXI from "pixi.js";
import {AbstractPixiRoot} from "../AbstractPixiRoot";
import {AbstractText} from "pixi.js/lib/scene/text/AbstractText";
import {StrokeAttributes} from "pixi.js/lib/scene/graphics/shared/FillTypes";

export class LibraryText extends GameObject {

  readonly fontName: string;
  readonly root: AbstractPixiRoot;

  constructor(root:AbstractPixiRoot, fontName: string) {
    super();
    this.root = root;
    this.fontName = fontName;
  }

  unloadAssets() {}

  override destroy(): void {
    this.unloadAssets();
    super.destroy();
  }

  createBitmapText(txt: string, maxWidth: number, maxHeight: number, align:PIXI.TextStyleAlign = 'center', fontSize = 75) {
    const text = new PIXI.BitmapText(txt,{
      align: align,
      fontFamily: this.fontName,
      fontSize: this.root.adapt(fontSize),
      fill: '#ffffff',
      wordWrap: true,
      wordWrapWidth: maxWidth,
    });
    this.fitText(text, maxWidth, maxHeight);
    return text;
  }

  // dialogTitleText(txt: string, maxWidth: number, maxHeight: number, fontSize = 75) {
  //   const text = new PIXI.BitmapText(txt,{
  //     // dropShadow: {
  //     //   alpha: 1,
  //     //   color: '#d39836', // Цвет тени,
  //     //   blur: 0,
  //     //   angle: -0.5, // Угол тени (45 градусов),
  //     //   distance: -4
  //     // },
  //     // fill: new PIXI.FillGradient({
  //     //   colorStops: [
  //     //     {color: '#f8de83', offset: 0},
  //     //     {color: '#ffffff', offset: 0.7},
  //     //   ]
  //     // }),
  //     align: 'center',
  //     fontFamily: TextManager.font_dialogTitle,
  //     fontSize: SandboxPixiRoot.adapt(fontSize),
  //     fill: '#ffffff',
  //     wordWrap: true,
  //     wordWrapWidth: maxWidth,
  //     // stroke: {
  //     //   color: '#ffffff',
  //     //   width: 3,
  //     //   join: 'round',
  //     // },
  //   });
  //   TextManager.fitText(text, maxWidth, maxHeight);
  //   return text;
  // }
  //
  // // менять размер только через входной аргумент fontSize !!!
  // dialogContentText(txt: string, maxWidth: number, maxHeight: number, fontSize = 75) {
  //   const text =  new PIXI.BitmapText(txt, {
  //     fill: '#ffffff', // Цвет текста
  //     align: 'center',
  //     fontFamily: TextManager.font_main,
  //     fontSize: SandboxPixiRoot.adapt(fontSize),
  //     wordWrap: true,
  //     wordWrapWidth: maxWidth,
  //     // stroke: {
  //     //   color: '#8B572A',
  //     //   // fill: new PIXI.FillGradient({
  //     //   //   textureSpace: 'local',
  //     //   //   colorStops: [
  //     //   //     {color: '#ffffff', offset: 0},
  //     //   //     {color: AssetsManager.color.main_light, offset: 0.3},
  //     //   //   ]
  //     //   // }),
  //     //   width: Main.adapt(fontSize / 3),
  //     //   join: 'round',
  //     // },
  //   });
  //   this.fitText(text, maxWidth, maxHeight);
  //   return text;
  // }

  private fitText(text:AbstractText, areaWidth:number, areaHeight:number) {
    const originalStyle = text.style.clone();
    let fontSize = originalStyle.fontSize || 16; // Начальный размер шрифта
    let wordWrapWidth = areaWidth; // Начальная ширина переноса
    // Итеративно уменьшаем размер шрифта, пока текст не впишется в область
    while (true) {
      text.style.fontSize = fontSize;
      let stroke = text.style.stroke as StrokeAttributes;
      if (stroke) {
        let newStroke = { ...stroke };
        newStroke.width = fontSize / 3;
        text.style.stroke = newStroke;
      }
      text.style.wordWrapWidth = wordWrapWidth;
      // Проверяем размеры текста
      const bounds = text.getSize();
      // console.warn(fontSize, bounds, this.areaWidth, this.areaHeight);
      if (bounds.width <= areaWidth && bounds.height <= areaHeight) {
        // console.warn('Text fit!');
        // const quad = ViewUtils.createGreenQuad(bounds.width, bounds.height, 0.5);
        // quad.position.set(this.position.x, this.position.y);
        // this.addChild(quad);
        break; // Текст помещается
      }
      fontSize--; // Уменьшаем шрифт
      if (fontSize < 8) {
        // console.warn('Text could not fit within the specified area');
        break;
      }
    }
  }

  // bitmapShadowText(txt: string, fontFamily = TextManager.main, textTint = TextManager.WHITE_COLOR, shadowTint = TextManager.MAIN_TEXT_COLOR, shadowOffset = 2) {
  // //   const container = new GameView();
  // //   const text = TextManager.bitmapFont(txt, fontFamily, textTint);
  // //   const shadow = TextManager.bitmapFont(txt, fontFamily, shadowTint);
  // //   container.addChild(shadow);
  // //   shadow.x = -Main.adapt(shadowOffset);
  // //   shadow.y = Main.adapt(shadowOffset);
  // //   container.addChild(text);
  // //   return container;
  // // }
}
